import i18next from 'i18next';
import { setLocale } from 'yup';

// Routes Yup's default string `min` message through i18n so the count is pluralized
// correctly ("1 character" vs "2 characters").
export const configureYupLocale = (): void => {
  setLocale({
    string: {
      min: ({ label, path, min }) => i18next.t('text:validation.stringMinChars', { label: label || path, count: min }),
    },
  });
};
